var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2746_4799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7644 2.37569C11.9494 1.18569 13.7748 1.08936 14.8423 2.15965C15.9097 3.22994 15.8127 5.06381 14.6277 6.25381L12.9107 7.97719M7.11649 9.9159C6.04903 8.8449 6.14607 7.01173 7.3304 5.82244L8.85403 4.29315",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88393 7.08203C10.9507 8.15303 10.8543 9.9862 9.6693 11.1755L7.9523 12.8989L6.2353 14.6222C5.05026 15.8122 3.22489 15.9086 2.15743 14.8383C1.08997 13.768 1.18701 11.9341 2.37206 10.7441L4.08905 9.02074",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2746_4799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarLink);
export default __webpack_public_path__ + "static/media/solar_link.a2eed059f7d469427770960851cf8ff3.svg";
export { ForwardRef as ReactComponent };